var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0002 11.8908L10.546 9.34562C11.0494 8.84213 11.3922 8.20067 11.5311 7.50236C11.6699 6.80404 11.5986 6.08023 11.3261 5.42246C11.0536 4.76468 10.5922 4.20247 10.0002 3.80692C9.40818 3.41138 8.71218 3.20026 8.0002 3.20026C7.28821 3.20026 6.59221 3.41138 6.00021 3.80692C5.4082 4.20247 4.94678 4.76468 4.67429 5.42246C4.4018 6.08023 4.33047 6.80404 4.46933 7.50236C4.60818 8.20067 4.95099 8.84213 5.4544 9.34562L8.0002 11.8908ZM11.3944 10.194L8.0002 13.5882L4.606 10.194C3.93473 9.52272 3.4776 8.66744 3.29241 7.73634C3.10722 6.80524 3.20229 5.84013 3.5656 4.96306C3.92891 4.08599 4.54414 3.33635 5.33349 2.80893C6.12284 2.28151 7.05086 2 8.0002 2C8.94954 2 9.87756 2.28151 10.6669 2.80893C11.4563 3.33635 12.0715 4.08599 12.4348 4.96306C12.7981 5.84013 12.8932 6.80524 12.708 7.73634C12.5228 8.66744 12.0657 9.52272 11.3944 10.194ZM3.8002 13.9998H12.2002V15.1998H3.8002V13.9998Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectLocation);
export default __webpack_public_path__ + "static/media/project_location.ba6dcca90508c7c8aea1e22fb1b9a694.svg";
export { ForwardRef as ReactComponent };